import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { AddNewTransactionDialogComponent } from './add-new-transaction-dialog.component';
import { DialogsService } from '../../../../../core/services/services';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';
import { SharedModule } from '../../../../shared/shared.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { PaymentElementModule } from '../../../../shared/payment-element/payment-element.module';

@NgModule({
  declarations: [AddNewTransactionDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    MatSelectModule,
    AppMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatStepperModule,
    PaymentElementModule,
  ],
  entryComponents: [AddNewTransactionDialogComponent],
  providers: [DialogsService],
  exports: [AddNewTransactionDialogComponent],
})
export class AddNewTransactionDialogModule {}
